import { Component } from '@angular/core';
import { FieldOpsAuthService } from '../../services/field-ops-auth.service';

@Component({
  selector: 'app-fo-connect',
  standalone: false,
  templateUrl: './fo-connect.component.html',
  styleUrls: ['./fo-connect.component.css']
})
export class FoConnectComponent {

  loading = false;
  error = '';

  constructor(private authService: FieldOpsAuthService) {}

  connect(): void {
    this.loading = true;
    this.error = '';
    this.authService.getAuthoriseUrl().subscribe({
      next: (response) => {
        window.location.href = response.url;
      },
      error: () => {
        this.loading = false;
        this.error = 'Failed to initiate connection. Please try again.';
      }
    });
  }
}
